import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import {
  Tabs,
  Menu,
  Table,
  Drawer,
  Modal,
  Form,
  Input,
  Button,
  Skeleton,
  Popconfirm,
  Select,
  message,
} from "antd";
import { isEmpty } from "lodash";

import { actionForAddCircularPlanningTemplate } from "services/redux/Reference/DynamicCircularTemplate/action";
import { getOrganizerEventPriorityListings } from "services/redux/organizer/priorityLisiting/action";

import { sectorListingParent } from "services/remanentCalls";
import { tenderTypeListing } from "services/redux/Reference/Tender/action";

const DynamicCircularAddTemplete = ({
  isOpen,
  onCancel,
  modalData,
  onSave,
  setIsCircularAddEditModalOpen,
  isCircularAddEditModalOpen,
  circularAddEdit,
  circularTemplateTitle,
}) => {
  const dispatch = useDispatch();
  const { Option } = Select;

  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const [form] = Form.useForm();
  const [formCircularEdit] = Form.useForm();

  const [typeListing, setTypeListing] = useState([]);
  const [sectors, setSectors] = useState([]);

  const priorityEventsState = useSelector((state) => state.priorityEvents);
  const { organizerEventPriorityListing } = priorityEventsState;

  const { tenderTypeListingResponse } = useSelector((state) => state.tender);

  const handleAddSubmit = async () => {
    let data = {};
    let values = await form.validateFields();
    data = {
      ...values,
      isactive: true,
      templatePriorityId: values?.organizerEventPriorityId,
    };
    console.log("actionForAddCircularPlanningTemplate:", data);
    try {
      dispatch(actionForAddCircularPlanningTemplate(data));
    } catch (err) {
      console.log("error: ", err);
    } finally {
      handleAddEditCancel();
    }
  };

  const handleEditSubmit = async () => {
    let update = {};
    let values = await form.validateFields();

    update = {
      ...values,
      id: selectedMenuItem,
      isactive: true,
      templatePriorityId: values?.organizerEventPriorityId,
    };
    try {
      dispatch(actionForAddCircularPlanningTemplate(update));
      //  setSelectedMenuItemTitle(update?.title);
    } catch (err) {
      console.log("error: ", err);
    } finally {
      handleAddEditCancel();
    }
  };

  const handleAddEditCancel = () => {
    setIsCircularAddEditModalOpen(false);
    form.resetFields();
  };

  const fetchAllSector = async () => {
    const resp = await sectorListingParent().catch((err) => {
      message.error("Failure");
    });

    if (resp && resp.status === 200) {
      setSectors(resp.data);
    }
  };

  useEffect(() => {
    console.log(circularAddEdit);
    setSelectedMenuItem(circularAddEdit?.data?.id);
    form.setFieldsValue({
      remarks: circularAddEdit?.data?.remarks,
      title: circularAddEdit?.data?.title,
      categoryId: circularAddEdit?.data?.categoryId,
      sectorId: circularAddEdit?.data?.sectorId,
    });
  }, [circularAddEdit, form]);

  useEffect(() => {
    if (!isEmpty(tenderTypeListingResponse)) {
      setTypeListing(tenderTypeListingResponse);
    }
  }, [tenderTypeListingResponse]);

  useEffect(() => {
    dispatch(tenderTypeListing());
    fetchAllSector();
    if (isEmpty(organizerEventPriorityListing)) {
      dispatch(getOrganizerEventPriorityListings());
    }
  }, []);

  return (
    <>
      {/* Modal */}
      <Modal
        title={circularTemplateTitle ? circularTemplateTitle : "Edit"}
        visible={isCircularAddEditModalOpen}
        onCancel={handleAddEditCancel}
        footer={null}
      >
        <Form name="basic" form={form}>
          <Form.Item
            label="Title"
            name="title"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Priority"
            name="organizerEventPriorityId"
            // className="form__group"
            initialValue={organizerEventPriorityListing[3]?.id}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              placeholder="Select Priority"
              autoComplete="off"
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {!isEmpty(organizerEventPriorityListing) &&
                organizerEventPriorityListing.map((status, index) => {
                  return (
                    <Option value={status.id} key={index}>
                      {status.name}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            name="categoryId"
            label="Category"
          >
            <Select
              allowClear
              size="small"
              showSearch={true}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {typeListing?.map((type) => (
                <Option key={type.id} value={type.id}>
                  {type.tenderTypeName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            name="sectorId"
            label="Sector"
          >
            <Select
              allowClear
              size="small"
              showSearch={true}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {sectors.map((data, i) => (
                <Option key={data.id} value={data.id}>
                  {data.sectorName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {circularAddEdit?.add ? (
            <Button onClick={handleAddSubmit} type="primary">
              Add
            </Button>
          ) : (
            <Button onClick={handleEditSubmit} type="primary">
              Update
            </Button>
          )}
        </Form>
      </Modal>
    </>
  );
};
export default DynamicCircularAddTemplete;
